/*
 * Port of php GeoUtilities
 */
interface Point {
  orientation: 'N' | 'S' | 'O' | 'V' | 'W' | 'E';
  degrees: number;
  minutes: number;
  seconds?: number;
}

class DmsPoint {
  lat: Point;
  lon: Point;

  constructor(lat: Point, lon: Point) {
    this.lat = lat;
    this.lon = lon;
  }
}

// Uncomment if you ever need to use this
/*
function dmsToDecimal(point: DmsPoint) {
  const $lon_data = point.lon;
  const $lat_data = point.lat;
  let $lon = Math.round($lon_data['degrees'] + $lon_data['minutes'] / 60 + $lon_data['seconds'] / 3600);
  let $lat = Math.round($lat_data['degrees'] + $lat_data['minutes'] / 60 + $lat_data['seconds'] / 3600);

  $lon = $lon_data.orientation === 'W' ? -1 * $lon : $lon;
  $lat = $lat_data.orientation === 'S' ? -1 * $lat : $lat;

  return [$lon, $lat];
}
*/

// Uncomment if you ever need to use this
/*
function decimalToDms($lon: number, $lat: number) {
  const $lat_direction = $lat < 0 ? 'S' : 'N';
  const $lon_direction = $lon < 0 ? 'W' : 'E';

  const $lat_in_degrees = Math.floor(Math.abs($lat));
  const $lon_in_degrees = Math.floor(Math.abs($lon));

  let $la_decimal = (Math.abs($lat) - $lat_in_degrees) * 60;
  let $lon_decimal = (Math.abs($lon) - $lon_in_degrees) * 60;

  const $lat_minutes = Math.floor($la_decimal);
  const $lon_minutes = Math.floor($lon_decimal);

  $la_decimal = ($la_decimal - $lat_minutes) * 60;
  $lon_decimal = ($lon_decimal - $lon_minutes) * 60;

  const $lat_seconds = Math.round($la_decimal);
  const $lon_seconds = Math.round($lon_decimal);

  return new DmsPoint(
    {
      orientation: $lon_direction,
      degrees: $lon_in_degrees,
      minutes: $lon_minutes,
      seconds: $lon_seconds,
    },
    {
      orientation: $lat_direction,
      degrees: $lat_in_degrees,
      minutes: $lat_minutes,
      seconds: $lat_seconds,
    }
  );
}
*/

// Uncomment if you ever need to use this
/*
function decToDMS($lat: number, $lon: number): DmsPoint {
  return decimalToDms($lon, $lat);
}
*/

const numberFormat = new Intl.NumberFormat('sv');

export function decToDMX($lat: number, $lon: number): DmsPoint {
  const $latDirection = $lat < 0 ? 'S' : 'N';
  const $lonDirection = $lon < 0 ? 'V' : 'O';

  const $latInDegrees = Math.floor(Math.abs($lat));
  const $lonInDegrees = Math.floor(Math.abs($lon));

  const $latDecimal = (Math.abs($lat) - $latInDegrees) * 60;
  const $lonDecimal = (Math.abs($lon) - $lonInDegrees) * 60;

  return new DmsPoint(
    {
      orientation: $lonDirection,
      degrees: $lonInDegrees,
      minutes: $lonDecimal,
    },
    {
      orientation: $latDirection,
      degrees: $latInDegrees,
      minutes: $latDecimal,
    }
  );
}

export function getCoordinates($point: DmsPoint): string {
  return `${$point.lat.orientation}${numberFormat.format($point.lat.degrees)}° ${numberFormat.format($point.lat.minutes)}" ${
    $point.lon.orientation
  } ${numberFormat.format($point.lon.degrees)}° ${numberFormat.format($point.lon.minutes)}"`;
}
